export default __webpack_public_path__ + "static/media/our-team-hero.ac422070.png";